// Reusable import-definition client: admin CRUD over saved import configs + the
// per-user grant endpoints (mirrors the forms grant wrappers). The config is an
// opaque JSON string the import wizard owns (stringify on save, parse on load).
import { api } from './api.js';
import { triggerDownload } from './export.js';

export async function listImportDefs() {
  const r = await api.get('/api/import-definitions');
  return r.imports || [];
}

export async function getImportDef(id) {
  return api.get(`/api/import-definitions/${id}`);
}

export async function createImportDef(body) {
  return api.post('/api/import-definitions', body);
}

export async function updateImportDef(id, body) {
  return api.patch(`/api/import-definitions/${id}`, body);
}

export async function deleteImportDef(id) {
  return api.delete(`/api/import-definitions/${id}`);
}

export async function getImportGrants(userId) {
  const r = await api.get(`/api/users/${userId}/import-grants`);
  return r.importIds || [];
}

export async function setImportGrants(userId, importIds) {
  return api.put(`/api/users/${userId}/import-grants`, { importIds });
}

// downloadImportTemplate triggers a download of the definition's empty .xlsx
// template (reusing export.js::triggerDownload, which sets the `download`
// attribute the @solidjs/router click-interceptor requires — PROJECT_NOTES §5).
export function downloadImportTemplate(id, filename) {
  triggerDownload(`/api/import-definitions/${id}/template`, filename || 'import-template.xlsx');
}
